<template>
    <div class="blackBg  animated slideInLeft">
        <div class="cardTit">
            <span class="season">{{$store.state.seasonName}}</span>
            <span class="teamName">{{teamName?teamName:'XXX'}}</span>
        </div>
        <div class="cardBg">
            <div class="left">
                <div class="battleArrayMap_inner">
                    <div
                            class="battleArrayMap_list"
                            v-if="list && list.lineup"
                            v-for="(player,i) in list.lineup"
                            :key="i+'_pos'"
                            :style="{position:'absolute',top: player.top ,left: player.left }">
                        <div v-for="(item,index) in maxLen" :key="item" class="battleArrayMap_item">
                            <template>
                                <div class="player-avatar" v-if="player.child[index]">
                                    <!-- crossorigin="anonymous" -->
                                    <img v-if="player.child[index].avatar" :src="player.child[index].avatar" crossorigin="anonymous" />
                                    <img v-else src="../assets/img/updateImg/playerHead.png" crossorigin="anonymous" />
                                </div>
                                <div class="player-avatar-empty player-avatar" v-else>
                                    <img src="../assets/img/lineup/empty-avatar.svg" />
                                </div>
                                <div class="number">{{player ? player.number : ''}}</div>
                                <div class="trial" v-if="player.child[index] && player.child[index].trial">
                                    <img src="../assets/img/lineup/trial.svg" alt />
                                </div>
                                <div class="playerName ellipsis">{{player.child[index] ? player.child[index].name : ''}}</div>
                                <div class="time">{{player.child[index] ? player.child[index].birthday : ''}}</div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="contentBox">
                    <div v-if="list && list[item.key] && list[item.key].length"  v-for="item in rightPlayer" style="clear: both">
                        <p class="battleArrayPersonnel_title" :class="item.key">{{item.label}}</p>
                        <div class="playerList">
                            <div v-for="player in list[item.key]" class="playerItem">
                                <div class="player-avatar">
                                    <img v-if="player.avatar" :src="player.avatar" crossorigin="anonymous" />
                                    <img v-else src="../assets/img/updateImg/playerHead.png" crossorigin="anonymous" />
                                </div>
                                <div class="playerName ellipsis">{{player.name ? player.name : ''}}</div>
                                <div class="time">{{player.birthday ? player.birthday : ''}}</div>
                            </div>
                        </div>
                    </div>
                  <div v-if="!(list['negtive'] && list['negtive'].length && list['delay'] && list['delay'].length && list['positive'] && list['positive'].length)" style="height: 30vw;text-align: center;font-size: 26px;line-height: 30vw">暂无数据</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "lineup",
        computed:{
            teamId() {
                return this.$store.state.teamId;
            }
        },
        data() {
            return {
                teamName: this.$store.state.teamName ? this.$store.state.teamName.split('_')[0] : '',//梯队名称
                maxLen: 3,//阵容最大显示长度
                list: {},
                rightPlayer: [
                    {
                        key: 'negtive',
                        label: '建议调整离队'
                    },
                    {
                        key: 'delay',
                        label: '待定'
                    },
                    {
                        key: 'positive',
                        label: '向上输送'
                    }
                ],
                scrollDomHeight: 0,
                time: null,
            }
        },
        watch: {
            teamId: {
                handler(val, old) {
                    if (val != old) {
                        this.teamName = this.$store.state.teamName.split('_')[0];//梯队名称
                        this.getLineUp()
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.getLineUp()
        },
        methods: {
            getLineUp() {
                let data = {
                    teamId: this.teamId,
                    // teamId: '5f09beab2bbde45f19a055b7',
                }
                this.$server.getLineUp(data)
                .then(res => {
                    this.list = res.data ? res.data : {};

                    let setTime = setTimeout(() => {
                        const lookEl = document.querySelector('.right');
                        const el = document.querySelector('.contentBox');
                        this.scrollDomHeight = el.offsetHeight - lookEl.offsetHeight;
                        console.log(this.scrollDomHeight);
                        if (this.scrollDomHeight > 0) {
                            setTimeout(() => {
                                this.scroll();
                                clearInterval(this.time)
                                this.time = setInterval(this.scroll, 10500);
                            }, 4000)
                        }
                        clearTimeout(setTime)
                    }, 100)
                })
            },
            //滚动数据
            scroll() {
                const el = document.querySelector('.contentBox');
                let style = el.getAttribute('style')
                if (style && style == 'margin-top:' + -(this.scrollDomHeight) + 'px') {
                    el.setAttribute('style', 'margin-top:' + 0 + 'px')
                } else {
                    el.setAttribute('style', 'margin-top:' + -(this.scrollDomHeight) + 'px')
                }
            }
        },
        destroyed() {
            clearInterval(this.time)
        }
    }
</script>

<style scoped lang="less">
    .cardTit{
        background-image: url("../assets/img/updateImg/head_2.png");
        position: relative;
        font-size: 30px;
        .season,.date{
            font-family: PingFangMedium;
            color: #fff;
            display: inline-block;
            line-height: 120px;
            position: absolute;
        }
        .season{
            line-height: 130px;
            left: 2vw;
        }
    }
    .cardBg {
        /*padding: 2vw;*/
        height: calc(100% - 100px);
        box-sizing: border-box;

        .playerName {
            width: 100%;
            color: rgba(255, 255, 255, 1);
            font-size: 18px;
            text-align: center;
            // margin-top: 10px;
            line-height: 16px !important;
            height: 16px;
            padding-top: 10px;
            padding-bottom: 3px;
        }
        .time {
            color: rgba(255, 255, 255, 0.8);
            font-size: 16px !important;
            margin-top: .5vw;
            height: 16px;
            font-family: PingFangBold;
        }
        .player-avatar {
            width: 2.5vw;
            height: 2.5vw;
            border-radius: 50%;
            box-shadow: 0 10px 20px rgba(21, 55, 24, 0.2);
            /*background: #f0f0f0;*/
            overflow: hidden;
            img {
                margin-top: 4px;
                width: 100%;
                height: auto;
            }
        }
    }

    .left {
        box-sizing: border-box;
        height: 100%;
        width: 60%;
        float: left;
        background-image: url('../assets/img/lineup/bg.png');
        background-size: 100% 100%;
        padding: 30px;
        .battleArrayMap_inner {
            position: relative;
            width: 100%;
            height: 100%;
        }
        .battleArrayMap_list {
            text-align: center;
            transform: translate(-50%);
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            .battleArrayMap_item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;
                width: 4.2vw;
                &:nth-child(2) {
                    margin: 0 5px;
                }
            }
            .number {
                font-family: PingFangBold;
                position: absolute;
                top: -2px;
                color: #3a3a44;
                right: 8px;
                width: 1vw;
                height: 1vw;
                text-align: center;
                line-height: 20px;
                background: url('../assets/img/lineup/Vector.svg') no-repeat;
                background-size: 100% 100%;
                z-index: 10;
                font-size: 12px;
                box-sizing: border-box;
            }
            .trial {
                position: absolute;
                left: 0;
                top: 12%;
            }
            .black {
                /*background: url('../../../../assets/images/gameimg/VectorAway.svg') no-repeat;*/
                background-size: 100% 100%;
                color: #fff;
            }
            .playerName {
                font-size: 18px;
            }
            .time {
                font-size: 16px;
            }
            .player-avatar {
                width: 2.5vw;
                height: 2.5vw;
                background: #f0f0f0;
            }
            .player-avatar-empty {
                background: transparent;
                img {
                    margin-top: 0;
                }
            }
        }
    }
    .right{
        height: 100%;
        width: 40%;
        float: left;
        padding-left: 1.5vw;
        box-sizing: border-box;
        overflow-y: auto;
        .contentBox{
            width: 100%;
            overflow-y: auto;
            transition: all 10s linear;
        }
        .battleArrayPersonnel_title {
            font-size: 26px;
            font-family: 'PingFangBold';
            padding-top: 1vw;
        }
        .playerItem{
            float: left;
            margin-right: 1.5vw;
            margin-top: 1vw;
            margin-bottom: 1vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .playerName {
            font-size: 22px;
            line-height: 25px;
            height: 25px;
        }
        .time {
            font-size: 20px;
            color: rgba(255, 255, 255, .7);
            font-family: PingFangMedium;
        }
        .player-avatar {
            width: 3vw;
            height: 3vw;
            background: #f0f0f0;
        }
        .negtive {
            color: #f95c51;
        }
        .delay {
            color: #ffc147;
        }
        .positive {
            color: #65b168;
        }
    }
</style>
